import styled, { keyframes } from 'styled-components';
import { PROGRESS_CIRCLE_SIZE } from '../constants';

export const CircleWrapper = styled.div`
  height: ${({ size }) => `${size}px`};
  margin: 0;
  padding: 0;
  position: relative;
  width: ${({ size }) => `${size}px`};
`;

export const CircleTrack = styled.circle`
  fill: transparent;
  stroke: ${({ theme }) => theme.color.progressTrack.background.value};
`;

export const FilledCircle = styled(CircleTrack)`
  stroke: ${({ theme }) => theme.color.primary[500].value};
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`;

export const FilledIndeterminateCircle = styled(CircleTrack)`
  stroke: ${({ theme }) => theme.color.primary[500].value};
  transform: rotate(-40deg);
  transform-origin: 50% 50%;
`;

export const dash = keyframes`
  0%{
    stroke-dasharray: 10,262;
    stroke-dashoffset: 0;
  }
  50%{
    stroke-dasharray: 200,272;
    stroke-dashoffset: -70;
  }
  100%{
    stroke-dasharray: 200,265;
    stroke-dashoffset: -272;
  }
`;

export const rotate = keyframes`
  100%{
    transform: rotate(360deg);
  }  
`;

export const getCircleSize = (size) => {
  switch (size) {
    case PROGRESS_CIRCLE_SIZE.SMALL:
      return 20;
    case PROGRESS_CIRCLE_SIZE.LARGE:
      return 48;
    case PROGRESS_CIRCLE_SIZE.EXTRA_LARGE:
      return 64;
    case PROGRESS_CIRCLE_SIZE.XXL:
      return 96;
    default:
      return 48; // defaults to "large" size
  }
};

export const getLabelSize = (circleSize) => {
  const rawlabelSize = Number(circleSize / 2);
  const labelSize = Math.max(rawlabelSize, 14);
  return labelSize;
};

export const getPercentLabelSize = (circleSize) => {
  const rawlabelSize = Number(circleSize / 3);
  const labelSize = Math.max(rawlabelSize, 16) - 2; // minimum of 14
  return Math.ceil(labelSize);
};
